import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import masLogo from "@/assets/mas-logo.png";

export function Navbar() {
  const { user, signOut } = useAuth();

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-sm">
      <nav className="container mx-auto flex h-16 items-center px-4">
        {/* Logo on the left */}
        <div className="flex-shrink-0">
          <Link to="/" className="flex items-center">
            <img src={masLogo} alt="MAS" className="h-10 w-auto" />
          </Link>
        </div>

        {/* MAS Matrimonial in the center */}
        <div className="flex-1 flex justify-center">
          <Link to="/" className="text-3xl font-black bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent hover:opacity-80 transition-opacity drop-shadow-sm">
            MAS Matrimonial
          </Link>
        </div>

        {/* Action buttons on the right */}
        <div className="flex-shrink-0 flex items-center gap-4">
          {user ? (
            <>
              <Link to="/dashboard">
                <Button variant="ghost">Dashboard</Button>
              </Link>
              <Button onClick={signOut} variant="outline">
                Sign Out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login">
                <Button variant="ghost">Login</Button>
              </Link>
              <Link to="/request-join">
                <Button>Request to Join</Button>
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
